/*
 * Find Your Colors map.
 * Progressive enhancement: server renders all region cards grouped by state;
 * this script upgrades the section into a zoomable US map with pins.
 */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-color-map]').forEach(initMap);

  function initMap(root) {
    var svg = root.querySelector('svg.usmap');
    var dataEl = root.querySelector('[data-color-map-data]');
    if (!svg || !dataEl) return;

    var regions;
    try {
      regions = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // leave the no-JS card list as-is
    }

    var backBtn = root.querySelector('.color-map__back');
    var hint = root.querySelector('[data-map-hint]');
    var groups = root.querySelectorAll('[data-panel-state]');
    var homeView = svg.getAttribute('viewBox') || '0 0 959 593';
    var currentState = null;

    // Hide all card groups until a state is chosen
    groups.forEach(function (g) {
      g.hidden = true;
    });

    // Index regions by state and mark those states on the map
    var byState = {};
    regions.forEach(function (r) {
      (byState[r.state] = byState[r.state] || []).push(r);
    });

    Object.keys(byState).forEach(function (st) {
      var path = svg.querySelector('[data-state="' + st + '"]');
      if (!path) return;
      path.classList.add('has-combos');
      path.setAttribute('tabindex', '0');
      path.setAttribute('role', 'button');
      path.setAttribute('aria-label', 'Show color combos for this state');
      path.addEventListener('click', function () {
        // Clicking the already-zoomed state zooms back out.
        if (currentState === st) reset();
        else zoomTo(st, path);
      });
      path.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (currentState === st) reset();
          else zoomTo(st, path);
        }
      });
    });

    backBtn.addEventListener('click', reset);

    // While zoomed: clicking any state without combos zooms back out.
    svg.addEventListener('click', function (e) {
      if (!currentState) return;
      var target = e.target.closest('[data-state]');
      if (target && !target.classList.contains('has-combos')) reset();
    });

    // Esc zooms back out.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && currentState) reset();
    });

    function zoomTo(st, path) {
      currentState = st;
      var b = path.getBBox();
      var pad = Math.max(b.width, b.height) * 0.25;
      var x = b.x - pad;
      var y = b.y - pad;
      var w = b.width + pad * 2;
      var h = b.height + pad * 2;

      // Expand the target box to the map's fixed aspect ratio so the
      // element never changes height — tall states gain horizontal
      // context, wide states gain vertical, always centered.
      var aspect = 959 / 593;
      if (w / h < aspect) {
        var nw = h * aspect;
        x -= (nw - w) / 2;
        w = nw;
      } else {
        var nh = w / aspect;
        y -= (nh - h) / 2;
        h = nh;
      }

      animateViewBox([x, y, w, h]);

      svg.querySelectorAll('.is-active').forEach(function (p) {
        p.classList.remove('is-active');
      });
      path.classList.add('is-active');

      showPanel(st);
      backBtn.hidden = false;
      if (hint) hint.hidden = true;
    }

    function reset() {
      currentState = null;
      animateViewBox(homeView.split(' ').map(Number));
      svg.querySelectorAll('.is-active').forEach(function (p) {
        p.classList.remove('is-active');
      });
      groups.forEach(function (g) {
        g.hidden = true;
      });
      backBtn.hidden = true;
      if (hint) hint.hidden = false;
    }


    function showPanel(st) {
      groups.forEach(function (g) {
        g.hidden = g.getAttribute('data-panel-state') !== st;
      });
    }


    var animFrame;
    function animateViewBox(target) {
      cancelAnimationFrame(animFrame);
      var from = svg.getAttribute('viewBox').split(' ').map(Number);
      if (reduceMotion) {
        svg.setAttribute('viewBox', target.join(' '));
        return;
      }
      var start = performance.now();
      var duration = 420;
      function frame(now) {
        var t = Math.min((now - start) / duration, 1);
        var e = 1 - Math.pow(1 - t, 3); // ease-out cubic
        var vb = from.map(function (f, i) {
          return f + (target[i] - f) * e;
        });
        svg.setAttribute('viewBox', vb.join(' '));
        if (t < 1) animFrame = requestAnimationFrame(frame);
      }
      animFrame = requestAnimationFrame(frame);
    }
  }
})();
